<template>
  <div>

    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />

    <v-dialog
      v-model="dialog"
      max-width="500px"
      persistent
    >
      <v-card>

        <!-- TITLE -->
        <v-card-title class="text-h6 pa-4">
          Change Super Admin
        </v-card-title>

        <v-divider></v-divider>

        <!-- BODY -->
        <v-card-text class="pa-6">

          <p class="text-body-1 mb-4">
            Select a user to transfer Super Admin ownership.
          </p>

          <v-select
            label="Select New Super Admin"
            :items="filteredUsers"
            item-title="user_name"
            item-value="user_id"
            v-model="selectedUserId"
            variant="outlined"
            density="comfortable"
            clearable
          />

        </v-card-text>

        <v-divider></v-divider>

        <!-- ACTIONS -->
        <v-card-actions class="pa-4">

          <v-spacer></v-spacer>

          <v-btn
            color="grey"
            variant="text"
            @click="handleClose"
          >
            Cancel
          </v-btn>

          <v-btn
            color="primary"
            variant="flat"
            :loading="loading"
            :disabled="!selectedUserId"
            @click="handleTransfer"
          >
            Transfer
          </v-btn>

        </v-card-actions>

      </v-card>
    </v-dialog>

  </div>
</template>

<script>

import SnackbarComponent from "@/components/Extras/Snackbar.vue";
import { generateClient } from "aws-amplify/api";
import { transfer_organization_ownership } from "@/graphql/mutations";

const client = generateClient();

export default {

  name: "ChangeSuperAdminDialog",

  components: {
    SnackbarComponent,
  },

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    users: {
      type: Array,
      default: () => [],
    },
    organization: {
      type: Object,
      default: null,
    },
  },

  emits: ["update:modelValue", "updated"],

  data() {
    return {
      loading: false,
      selectedUserId: null,

      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },

  computed: {

    dialog: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },

    // Filter Admin & Pharmacist users
    filteredUsers() {
      return this.users.filter(
        (u) => (u.user_type === "ADMIN" || u.user_type === "PHARMACIST") &&  u.user_license_type === "ANNUAL"
      );
    },
  },

  watch: {
    modelValue(val) {
      if (val) {
        this.selectedUserId = null;
      }
    },
  },

  methods: {

    handleClose() {
      this.dialog = false;
    },

    async handleTransfer() {

      if (!this.selectedUserId) return;

      this.loading = true;

      try {

        const input = {
          organization_id: this.organization.organization_id,
          new_owner_user_id: this.selectedUserId,
        };

        const response = await client.graphql({
          query: transfer_organization_ownership,
          variables: {
            input: input,
          },
        });

        const responseData = JSON.parse(
          response.data.transfer_organization_ownership
        );

        if (responseData.status === "SUCCESS") {

          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              "Super Admin ownership transferred successfully",
            color: "success",
          };

          this.$emit("updated");

          this.handleClose();

        } else {

          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              "Failed to transfer Super Admin ownership",
            color: "error",
          };

        }

      } catch (error) {

        console.error("Transfer error:", error);

        this.snackbar = {
          show: true,
          message:
            error?.errors?.[0]?.message ||
            "Failed to transfer Super Admin ownership",
          color: "error",
        };

      }

      this.loading = false;
    },
  },
};
</script>

<style scoped>
</style>